import './basicCss.scss';
import React from 'react';
import SliderMenu from '../components/sliderMenu/index.jsx'
import Header from '../components/header/index.jsx'
import GlobalStore from '../components/globalStore/index.jsx'
import {Provider} from 'react-redux'
import store from "../store/index.js"
import moment from 'moment';
import 'moment/locale/zh-cn';
import api from "../lib/api";
import {Route, Switch, Redirect,withRouter} from "react-router-dom";
import routes from '../router/router.js'
import {message} from "antd";
moment.locale('zh-cn');
class BasicLayout extends React.Component {
  state = {
    name: '',
    collapsed: false,
    sysVal: '',
    sysList: []
  };
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };
  // 系统值改变
  sysValChange = (val) => {
    this.setState({sysVal: val});
    sessionStorage.setItem('projectId', val);
    window.location.reload();
  };
  // 获取系统数据
  getSysList() {
    api
      .getSysList({})
      .then(res => {
        if (res.success && res.status === 200) {
          this.setState({
            sysList: res.data || null,
            sysVal: Number(sessionStorage.getItem('projectId')) || res.data[0].id || null
          });
          if (!sessionStorage.getItem('projectId'))
            sessionStorage.setItem('projectId', res.data[0].id || '');
          }
        else {
          message.error(res.message);
        }
      })
  };
  setName = (name) => {
    this.setState({name: name})
  };
  UNSAFE_componentWillMount() {
    this.getSysList();
  };
  render() {
    const {name, collapsed, sysVal, sysList} = this.state;
    return (
      <div className="basic-layout">
        <Provider store={store}>
          <GlobalStore/>
          <SliderMenu collapsed={collapsed} setName={this.setName} routeData={this.props}/>
          <Header
            name={name}
            collapsed={collapsed}
            sysVal={sysVal}
            sysList={sysList}
            toggleCollapsed={this.toggleCollapsed}
            sysValChange={this.sysValChange}
            routeData={this.props}/>
          {sysVal ? <main className="app-route-main">
          <Switch>
            {
              routes.map((route,key)=>{
                  if(route.exact){
                    return <Route key={key} exact path={route.path}
                    render={props => (
                      <route.component {...props} routes={route.children} />
                    )}
                    />
                  }else{
                    return <Route  key={key}  path={route.path}
                    render={props => (
                      <route.component {...props} routes={route.children} />
                    )}
                    />
                  }
              })
            }
            <Redirect to='/apm/home'/>
            </Switch>
          </main> : ''}
        </Provider>
      </div>
    );
  };
};

export default withRouter(BasicLayout);
